// @flow
import * as React from 'react'

import { RoomCard } from '@/components'
import Strings from '@/constants'
import { sortByPricing } from '@/helpers'
import { Property } from '@/models'
import type { RoomDataType } from '@/models/property'

import styles from '../styles.scss'
import RatesModal from './rates-modal'
import NoRooms from '../no-rooms'

type RoomTabProps = {
  code: string,
  name: string,
  rooms: Array<RoomDataType>,
  chooseRoom: (roomId: string, rateId: string, checkLink: string) => void,
  goBack: () => void,
}

// eslint-disable-next-line no-unused-vars
export const RoomTab = ({ code, name, rooms, chooseRoom, goBack }: RoomTabProps) => {
  const [modalOpen, setModalOpen] = React.useState(false)
  const [selectedRoom, setSeletedRoom] = React.useState<RoomDataType | null>(null)

  const onClick = (room: RoomDataType) => {
    setSeletedRoom(room)
    setModalOpen(true)
  }

  React.useEffect(() => {
    if (modalOpen) {
      // $FlowFixMe
      document.body.style.top = `-${window.scrollY}px`
      // $FlowFixMe
      document.body.style.position = 'fixed'
    } else {
      // $FlowFixMe
      document.body.style.position = ''
      // $FlowFixMe
      document.body.style.top = ''
    }

    return () => {
      // $FlowFixMe
      document.body.style.position = ''
      // $FlowFixMe
      document.body.style.top = ''
    }
  }, [modalOpen])

  return (
    <div className={styles.roomTab} key="RoomTab">
      {rooms.length > 0 && [...rooms.sort(sortByPricing)].map(room => (
        <RoomCard room={room} key={room.id} chooseRoom={onClick} />
      ))}
      {rooms.length === 0 && <NoRooms name={name} onClick={goBack} />}
      {modalOpen && selectedRoom && (
        <RatesModal
          rates={selectedRoom?.rates || []}
          onClose={() => {
            setModalOpen(false)
            setSeletedRoom(null)
          }}
          chooseRoom={(rateId, checkLink) => chooseRoom(selectedRoom?.id, rateId, checkLink)}
        />
      )}
    </div>
  )
}

type DiningTabProps = {
  description: string,
}

export const DiningTab = ({ description }: DiningTabProps) => (
  <div className={styles.diningTab} key="DiningTab">
    <div className={styles.tabInfoBlock}>
      <h3>{Strings.hotelInfo.diningAndEntertainment}</h3>
      <p dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  </div>
)

type FacilitiesTabProps = {
  property: Property,
}

export const FacilitiesTab = ({ property }: FacilitiesTabProps) => {
  const { amenities, policies, checkin, checkout } = property.metadata

  return (
    <div className={styles.facilitiesTab} key="FacilitiesTab">
      <div className={styles.tabInfoBlock}>
        <h3>{Strings.hotelInfo.hotelPolicies}</h3>
        <div>
          <span>
            {Strings.hotelInfo.checkIn(checkin.begin_time, checkin.end_time)}
          </span>
        </div>
        <div>
          <span>{Strings.hotelInfo.checkOut(checkout.time)}</span>
        </div>
        {checkin.instructions && <p dangerouslySetInnerHTML={{ __html: checkin.instructions }} />}
        {checkin.special_instructions && (
          <p dangerouslySetInnerHTML={{ __html: checkin.special_instructions }} />
        )}
      </div>
      {policies.know_before_you_go && (
        <div className={styles.tabInfoBlock}>
          <h3>{Strings.hotelInfo.generalPolicies}</h3>
          <div className={styles.spacedLined}>
            <p dangerouslySetInnerHTML={{ __html: policies.know_before_you_go }} />
          </div>
        </div>
      )}
      <div className={styles.tabInfoBlock}>
        <h3>{Strings.hotelInfo.hotelAmenities}</h3>
        <div className={styles.amenitiesSection}>
          {Object.values(amenities).map(item => (
            // $FlowFixMe
            <div key={item.name}>
              {/* $FlowFixMe */}
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
